import { render, staticRenderFns } from "./v-logo.vue?vue&type=template&id=5567db9a&"
import script from "./v-logo.vue?vue&type=script&lang=js&"
export * from "./v-logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports